var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { List } from '../List';
export class Account extends Component {
    constructor() {
        super('Account', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('#btn-show-forgotten-password').on('click', (event, button) => {
                event.preventDefault();
                $('#panel-login').addClass('d-none');
                $('#panel-lostpassword').removeClass('d-none');
            });
            $('.btn-open-account').on('click', (event, button) => {
                event.preventDefault();
                $('.aside-panel').addClass('d-none');
                $('#account').removeClass('d-none');
                $('#panel-login').removeClass('d-none');
                $('#panel-lostpassword').addClass('d-none');
                if ($('#signin-email').length > 0)
                    $('#signin-email').get(0).focus();
            });
            $('body').on('click', '#btn-login', (event) => {
                event.preventDefault();
                this.login();
            });
            $('body').on('click', '#btn-register', (event) => {
                event.preventDefault();
                this.register();
            });
            $('body').on('click', '#btn-update', (event) => {
                event.preventDefault();
                this.update();
            });
            $('body').on('click', '.btn-load-list', (event, item) => {
                event.preventDefault();
                let doLoad = true;
                if (List.status == 'unsaved')
                    doLoad = confirm($('html').attr('lang') == 'fr_FR' ? 'Votre liste actuelle n\'a pas été sauvegardé. Êtes-vous certain de vouloir l\'écraser par celle-ci?' : 'Your current list has not been saved. Are you sure you want to overwrite it with this one?');
                if (doLoad) {
                    List.load(item.data('id'), item.text(), 'saved', item.parents('li').find('.json').text());
                    $('#account').addClass('d-none');
                    $('#list').removeClass('d-none');
                }
            });
            $('body').on('click', '.btn-remove-list', (event, item) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                const list_id = item.data('id');
                item.parents('li').css('opacity', '0.5');
                item.next().removeClass('d-none');
                item.css('opacity', '0');
                yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    body: {
                        'action': 'remove_list',
                        'list_id': list_id
                    },
                    dataType: 'json',
                });
                Account.refresh();
            }));
            $('body').on('submit', '.lost_reset_password', (event, form) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                const response = yield $.httpRequest({
                    url: $('#form-target').val(),
                    type: 'POST',
                    body: {
                        'wc_reset_password': 'true',
                        'user_login': $('#user_login').val(),
                        'woocommerce-lost-password-nonce': $('#woocommerce-lost-password-nonce').val(),
                        '_wp_http_referer': window.location
                    },
                    dataType: 'html',
                });
                if (response.search('meta') == 0) {
                    $('#panel-lostpassword').empty().append(response);
                }
                else {
                    const message = $('html').attr('lang') == 'fr_FR' ? 'Un e-mail de réinitialisation de mot de passe a été envoyé à l’adresse e-mail de votre compte, mais cela peut prendre plusieurs minutes avant qu’il ne s’affiche dans votre boîte de réception. Veuillez patienter au moins 10 minutes avant de tenter une autre réinitialisation.' : 'A password reset email has been sent to your account email address, but it may take several minutes for it to appear in your inbox. Please wait at least 10 minutes before attempting another reset.';
                    $('#panel-lostpassword').empty().append($.parseHTML('<p>' + message + '</p>'));
                }
                console.log();
            }));
            this.success();
        });
    }
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            $('#btn-login').addClass('loading');
            $('#msg-signin').addClass('d-none').text('');
            const nonce = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'get_login_nonce'
                },
                dataType: 'json',
            });
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'login',
                    'nonce': nonce,
                    'username': $('#signin-email').val(),
                    'password': $('#signin-password').val(),
                },
                dataType: 'json',
            });
            if (!response.loggedin) {
                $('#msg-signin').removeClass('d-none').text(response.message);
            }
            else {
                yield Account.refresh();
                $('body').addClass('logged-in');
                $('.btn-open-account').text($('html').attr('lang') == 'fr_FR' ? 'Mon compte' : 'My account');
            }
            $('#btn-login').removeClass('loading');
        });
    }
    register() {
        return __awaiter(this, void 0, void 0, function* () {
            $('#btn-register').addClass('loading');
            $('#msg-register').addClass('d-none').text('');
            const nonce = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'get_register_nonce'
                },
                dataType: 'json',
            });
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'register',
                    'nonce': nonce,
                    'email': $('#register-email').val(),
                    'firstname': $('#register-firstname').val(),
                    'lastname': $('#register-lastname').val(),
                    'password_1': $('#register-password_1').val(),
                    'password_2': $('#register-password_2').val(),
                    'lang': $('html').attr('lang')
                },
                dataType: 'json',
            });
            if (!response.registered) {
                $('#msg-register').removeClass('d-none').text(response.message);
            }
            else {
                Account.refresh();
            }
            $('#btn-register').removeClass('loading');
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            $('#btn-update').addClass('loading');
            $('#msg-update').addClass('d-none').text('');
            const nonce = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'get_update_account_nonce'
                },
                dataType: 'json',
            });
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'update_account',
                    'nonce': nonce,
                    'firstname': $('#account-firstname').val(),
                    'lastname': $('#account-lastname').val(),
                    'email': $('#account-email').val(),
                    'password_1': $('#account-password_1').val(),
                    'password_2': $('#account-password_2').val(),
                },
                dataType: 'json',
            });
            if (!response.updated) {
                $('#msg-update').removeClass('d-none').text(response.message);
            }
            else {
                yield Account.refresh();
                $('#msg-update-success').removeClass('d-none');
                setTimeout(() => {
                    $('#msg-update-success').addClass('d-none');
                }, 5000);
            }
            $('#btn-update').removeClass('loading');
        });
    }
    static refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const accountHTML = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'get_component',
                    'component': 'Account',
                    'lang': $('html').attr('lang')
                },
                dataType: 'html',
            });
            $('#account').empty().append(accountHTML);
        });
    }
}
